import React from "react";

import { getQueryParam } from "src/common/utils/location";

export function useQueryParam(key: string): string | undefined {
	return React.useMemo(() => getQueryParam(key), [key]);
}
